import { apiTreeUrl, bundledBrands, deriveName, slugFromTreePath, type Brand } from './index';

type FetchFn = (url: string) => Promise<Response>;
interface TreeEntry { path: string; type: string; }

export async function refreshBrandIndex(fetchFn: FetchFn = fetch): Promise<Brand[]> {
  try {
    const res = await fetchFn(apiTreeUrl());
    if (!res.ok) return bundledBrands();
    const data = (await res.json()) as { tree?: TreeEntry[] };
    const slugs = (data.tree ?? [])
      .map((e) => slugFromTreePath(e.path))
      .filter((s): s is string => s !== null);
    if (slugs.length === 0) return bundledBrands();
    return slugs
      .map((slug) => ({ slug, name: deriveName(slug) }))
      .sort((a, b) => a.slug.localeCompare(b.slug));
  } catch {
    return bundledBrands();
  }
}
